<template>
    <div v-wechat-title="title">
        <el-row>
            <el-col :span="collapseleft == 0 ? 3 : 0" style="border-right: 2px solid #ebeef5">
                <!-- 扫手术间条码，定位到对应手术间 -->
                 <el-row type="flex" align="middle">
                    <item-input ref="scan-room" type="scan" v-model="scanroom" placeholder="请扫手术间条码" :autofocus="true" @input="scanRoom" ></item-input>
                 </el-row>
                <el-scrollbar :style="{ height: `${this.screenHeight - 153}px`, background: `white` }">
                    <el-menu class="cus-menu-v surgery" :unique-opened="false" :default-openeds="openeds">
                        <template >
                            <el-submenu v-for="g in wardRooms" :index="g.value.toString()" :key="g.value">
                                <div slot="title" class="cus-collapse-item" style="text-align: left;">
                                    <span v-if="g.change_type && g.change_type == 1" class="el-icon-warning" style="color: red;"></span>
                                    <span style="font-size: 16px;">
                                        {{ g.label }}
                                    </span>
                                </div>
                                <div v-if="g.operation_room && g.operation_room.length > 0" style="margin-top: 5px;cursor: pointer;">
                                    <div class="rooms-wrapper" v-for="d in g.operation_room" :key="d.value" @click="loadApplyDetail(d,g)">
                                            <div class="rooms" :style="getRoomStyle(d)">
                                                <span style="color: black;padding-left: 20px;">{{ d.label }}</span>
                                                <span
                                                class="changetag"
                                                    :style="getChangeColor(d.info[0].change_type)"
                                                    v-if="d.info && d.info.length > 0 && d.info[0].change_type != 0"
                                                    >{{d.info[0].change_type_lable}}</span
                                                >
                                            </div>
                                    </div>
                                </div>
                            </el-submenu>
                        </template>
                    </el-menu>
                </el-scrollbar>
            </el-col>
            <el-col :span="collapseleft == 0 ? 21 : 24">
                <el-row type="flex" align="middle">
                    <el-col :md="1" class="align-left">
                        <i style="cursor: pointer;font-size: larger;" :class="collapseleft == 1 ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="triggerCollapse()"></i>
                    </el-col>
                    <el-col :md="5" class="align-left" v-if="active_room && applytype == 2 && (isHavePermissions(`zq`) || isHavePermissions(`jz`))">
                        <el-radio-group v-model="roomApplyType" size="mini" style="text-align: left">
                            <el-radio-button label="2" v-if="isHavePermissions(`zq`)">择期</el-radio-button>
                            <el-radio-button label="1" v-if="isHavePermissions(`jz`)">急诊</el-radio-button>
                        </el-radio-group>
                    </el-col>
                    <el-col :md="5" class="align-left" v-if="active_room">
                        <span style="line-height: 35px;" v-html="activeTitle"></span>
                    </el-col>
                    <el-col :md="5" class="align-left">
                        <item-input type="datearraw2" v-model="queryday" style="width: 160px"></item-input>
                    </el-col>
                    <el-col :md="5" class="align-left" v-if="isHavePermissions(`scan`) && active_room && applyStatus!=0">
                        <item-input
                            ref="scan-code"
                            type="scan"
                            v-model="scancode"
                            placeholder="请扫码/输入条形码"
                            :autofocus="true"
                            @input="scanConsumable"
                        ></item-input>
                    </el-col>
                    <el-col :md="5">
                        <item-input type="search" placeholder="关键字搜索" v-model="searchValue" @input="search()"></item-input>
                    </el-col>
                    <el-col class="align-right">
                        <el-button type="primary" size="mini" v-if="active_room && showRemove" @click="removeSupplies">耗材转移</el-button>
                        <el-button type="primary" size="mini" v-if="active_room" @click="refreshList">刷新</el-button>
                        <el-button size="mini" v-if="active_room && active_room.info" @click="applyLog">操作日志</el-button>
                        <!-- 护理耗材由发放室的人直接发放 急诊由他人在发放室人电脑上输入账号密码发放 -->
                        <!-- applyStatus!=0：申领或补领 applytype=1：麻醉耗材   保存列表数据 -->
                        <el-button type="primary" size="mini" v-if="isHavePermissions(`save`) && active_room && applyStatus!=0 && applytype==1" @click="saveSupplies">保存</el-button>
                        <!-- applyStatus!=0：申领或补领 applytype=2：护理耗材 roomApplyType=1：急诊  弹出账号密码填写发放人 -->
                        <el-button type="primary" size="mini" v-if="isHavePermissions(`confirm`) && active_room && applyStatus!=0 && (applytype==2 && roomApplyType==1)" @click="showLock">确认</el-button>
                        <!-- applyStatus!=0：申领或补领 applytype=1：麻醉耗材 roomApplyType=2：或护理择期 确认耗材发放数 -->
                        <el-button type="primary" size="mini" v-if="isHavePermissions(`confirm`) && active_room && applyStatus!=0 && (applytype==1 || roomApplyType==2)" @click="confirmSupplies">确认</el-button>
                        <el-button type="primary" size="mini" v-if="isHavePermissions(`gettemp`) && active_room && applyStatus!=0" @click="loadTemplatesView">提取模板</el-button>
                        <el-button type="primary" size="mini" v-if="isHavePermissions(`savetemp`) && active_room" @click="SaveAsTemplate">另存为模板</el-button>
                        <el-button type="primary" size="mini" v-if="isHavePermissions(`export`) && active_room" @click="exportApply">导出</el-button>
                        <el-button type="primary" size="mini" v-if="isHavePermissions(`print`) && active_room" @click="printApply">打印</el-button>
                        <el-popover placement="bottom" :open-delay="600">
                            <el-button size="mini" plain slot="reference">
                                <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                <span class="hidden-md-and-down">&nbsp;列配置</span>
                            </el-button>
                            <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 250px; width: 100px;">
                                <div class="config-column">
                                    <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                                </div>
                            </el-scrollbar>

                            <el-divider></el-divider>
                            <div style="text-align: right">
                                <el-link type="primary" size="mini" class="margin-right10" @click="SaveUserColumns">保存</el-link>
                            </div>
                        </el-popover>
                    </el-col>
                </el-row>
                <list-view
                    :showSequence="true"
                    ref="sprescription-list"
                    :datalist="datalist"
                    :tableHeight="this.screenHeight - 155"
                    @extrabutton-click="ExtraButtonClick"
                    :columns="userListColumn"
                    :buttons="[]"
                    :reserveSelection="false"
                    :stripe="false"
                >
                </list-view>
            </el-col>
        </el-row>
        <cus-dialog class="table-h360" title="提取模板" :visible.sync="supplies.dialogFormVisible" :close-on-click-modal="false" width="60%" @confirm="addTemplateToList">
            <el-row class="padding20">
                <el-col :span="2" class="align-left"><span class="line-height35">请选模板:</span></el-col>
                <el-col :span="22">
                    <item-input type="groupselect" :collapseTags="false" v-model="supplies.selected_template" :options="supplies.supplies_template" :clearable="true"></item-input>
                </el-col>
            </el-row>
            <list-view :columns="supplies.columnList" :datalist="supplies.datalist" :selectAll="true" :selection="true" @extrabutton-click="ExtraButtonClick"></list-view>
        </cus-dialog>
        <SaveAs :visible.sync="saveas.dialogFormVisible" :applytype="applytype" class="table-h360" :data="saveas.data" @save-success="saveAsSuccess"></SaveAs>
        <el-dialog ref="form_unlock" title="申请人" :close-on-click-modal="true"
            :visible.sync="alterPasswordDialog.dialogFormVisible" width="30%">
            <el-row>
                <el-input v-model="alterPasswordDialog.data.uid" ref="uid" :clearable="true" :autofocus="true">
                    <template slot="prepend">
                        <i class="el-icon-user"></i>
                    </template>
                </el-input>
            </el-row>
            <el-row>
                <el-input v-model="alterPasswordDialog.data.pwd" ref="pwd" show-password :clearable="true">
                    <template slot="prepend">
                        <i class="el-icon-lock"></i>
                    </template>
                </el-input>
            </el-row>
            <el-row slot="footer" class="dialog-footer">
                <el-button @click="alterPasswordDialog.dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmSuppliesByWorker()">确 定</el-button>
            </el-row>
        </el-dialog>
        <el-dialog :title="applyLogView.title" :close-on-click-modal="false" :visible.sync="applyLogView.dialogFormVisible" class="table-h560" width="60%">
            <ListView :datalist="applyLogView.data" :columns="applyLogView.columns" :buttons="[]" @extrabutton-click="logExtraButtonClick"></ListView>
            <span slot="footer" class="dialog-footer">
                <el-button @click="applyLogView.dialogFormVisible = false">关 闭</el-button>
            </span>
        </el-dialog>

        <cus-dialog class="table-h360" title="耗材转移" :visible.sync="removeView.dialogFormVisible" :close-on-click-modal="false" width="60%" @confirm="removeSuppliesSave">
            <el-row>
                <el-col :span="24" class="align-center">
                    <span class="line-height35">术间耗材转移：</span>
                    <span style="font-weight: 600;">
                        {{active_room && active_room.label}}
                    </span>
                    <span class="el-icon-right"></span>
                    <item-input style="width: 200px;" type="select" v-model="removeView.toRoomId" :options="activeWardRooms" :clearable="true"></item-input>
                </el-col>
            </el-row>
            <list-view :columns="removeView.columns" :datalist="removeView.data" :selectAll="true" :selection="true" @extrabutton-click="ExtraButtonClick"></list-view>
        </cus-dialog>
    </div>
</template>
<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import { mapGetters } from 'vuex'
import Sortable from 'sortablejs'
import SaveAs from '@/components/Dictionary/Supplies/SaveAs.vue'
export default {
    name: `SupplyApply`,
    components: { SaveAs },
    props: {},
    data() {
        return {
            title: parseInt(this.$route.query.applytype || 1) == 2 ? `护理耗材申领` : `麻醉耗材申领`,
            applytype: parseInt(this.$route.query.applytype || 1),
            scanroom: ``,
            showRemove: false,
            saveas: {
                dialogFormVisible: false,
                data: {}
            },
            checkedRow: [],
            scancode: ``,
            username: ``,
            tableName: `api_Counting/SupplyApply`,
            active_apply: null,
            active_room: null,
            activeWardRooms: [],
            supplyApplyScheduleTime: this.$root.SupplyApplyScheduleTime || `08:00`,
            queryday: this.$moment().format(`YYYY/MM/DD ${this.supplyApplyScheduleTime}`),
            wardRooms: [],
            collapseleft: 0,
            searchValue: ``,
            roomApplyType: 2,
            groupbyList: [
                { value: 2, label: `择期` },
                { value: 1, label: `急诊` }
            ],
            user_config_columns: [],
            configColumns: [],
            datalist: [],
            all_data_list: [],
            supplies: {
                dialogFormVisible: false,
                selected_template: undefined,
                supplies_template: [],
                cache_template: {},
                datalist: [],
                columnList: [
                    {
                        type: `string`,
                        prop: `dic_supplies_id`,
                        label: `编号`,
                        isKey: true
                    },
                    {
                        type: `string`,
                        prop: `name`,
                        label: `名称`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `code`,
                        label: `编码`,
                        width: `180`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `category`,
                        label: `耗材类型`,
                        width: `120`,
                        isListable: true
                    },
                    {
                        type: `string`,
                        prop: `spec`,
                        label: `规格`,
                        width: `120`,
                        isListable: true
                    },
                    {
                        type: `number`,
                        prop: `quantity`,
                        label: `数量`,
                        width: `100`,
                        isListable: true
                    }
                ]
            },
            alterPasswordDialog: {
                dialogFormVisible: false,
                data: {
                    uid: ``,
                    pwd: ``,
                    exp: 100000
                }
            },
            applyLogView: {
                title: `申领日志`,
                dialogFormVisible: false,
                data: [],
                columns: [{
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `supplie_name`,
                    label: `耗材`,
                    isListable: true,
                    width: 80
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `操作记录`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `操作人`,
                    width: 80,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `create_date`,
                    label: `操作时间`,
                    isListable: true
                }
                ]
            },
            removeView: {
                dialogFormVisible: false,
                toRoomId: undefined,
                data: [],
                columns: [{
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                },
                {
                    type: `string`,
                    prop: `dic_supplies_name`,
                    label: `名称`,
                    width: `300`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_supplies_id`,
                    label: `dic_supplies_id`,
                    isListable: false,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `integer`,
                    prop: `prepare_quantity`,
                    label: `发放数`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `integer`,
                    prop: `reduce_quantity`,
                    label: `转移数`,
                    isListable: true,
                    readonly: false
                }]
            }
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `operation_ward_auth`, `operation_ward_auth_disabled`, `permissions`, `currentUser`, `screenHeight`, `active_ward`, `sys_enums`, `section_auth`, `sysuser/workers_by_duty`]),
        openeds() {
            return this.wardRooms.map(i => i.value.toString())
        },
        activeTitle() {
            let title = this.active_room.label + `${this.applytype && this.applytype == 1 ? (this.applyStatus == 1 ? `<span style="color: red;">耗材补领</span>` : this.applyStatus == 2 ? `耗材请领` : `耗材申请`) : `耗材发放`}`
            return title
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return this.columnList
            } else if (this.user_config_columns.length == 0) {
                that.user_config_columns = that.configColumns.map(c => c.value)
                return this.columnList
            }
            let allcolumn = _.filter(this.columnList, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            let addData = this.datalist && _.filter(this.datalist, d => {
                return d.add_quantity > 0
            })
            if (!addData || addData.length <= 0) {
                r = _.filter(r, c => {
                    return c.prop != `add_quantity`
                })
            }
            let reduceData = this.datalist && _.filter(this.datalist, d => {
                return d.reduce_quantity > 0
            })
            if (!reduceData || reduceData.length <= 0) {
                r = _.filter(r, c => {
                    return c.prop != `reduce_quantity`
                })
            }
            // 是否有转入转出来控制列的显示隐藏
            return r
        },
        columnList() {
            let me = this
            // applyStatus 0仅查看 1补领 2请领
            let isedit = me.isHavePermissions(`save`)
            let deletep = me.isHavePermissions(`delete`) && me.applyStatus != 0
            let mzconfirmp = me.isHaveMZPermissions(`confirm`)
            return [
                {
                    type: `string`,
                    prop: `___index`,
                    label: `unique`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`
                },
                {
                    type: `remoteselect`,
                    prop: `dic_supplies`,
                    label: `名称`,
                    width: `300`,
                    isListable: true,
                    options: `/api/AcisSystem/Supplies/SearchSpec?applytype=${me.applytype || 1}`,
                    change: (that, { row, index }) => {
                        if (row.dic_supplies && row.dic_supplies.value) {
                            let hadrow = _.find(me.datalist, { dic_supplies_id: row.dic_supplies.value })
                            if (hadrow) {
                                this.$set(row, `dic_supplies`, null)
                                me.$message.error(`请勿添加重复项`)
                            } else {
                                let req = me.myaxios.get(`/api/AcisSystem/Supplies/Get/${row.dic_supplies.value}`)
                                if (index + 1 == me.datalist.length) {
                                    me.datalist.push({ ___index: _.now(), exists_black: 1 })
                                }
                                req.then(data => {
                                    me.$set(row, `dic_supplies_id`, data.id)
                                    me.$set(row, `spec`, data.spec)
                                    me.$set(row, `firm`, data.firm)
                                    me.$set(row, `pkg_unit`, data.pkg_unit)
                                    me.$set(row, `price`, data.price)
                                    me.$set(row, `apply_count`, ``)
                                    me.$set(row, `apply_count`, ``)
                                    me.$set(row, `supplement_count`, ``)
                                    me.$set(row, `supplement_count_old`, ``)
                                })
                            }
                        } else {
                            me.$set(row, `dic_supplies_id`, ``)
                            me.$set(row, `spec`, ``)
                            me.$set(row, `firm`, ``)
                            me.$set(row, `apply_count`, ``)
                            me.$set(row, `apply_count_old`, ``)
                            me.$set(row, `pkg_unit`, ``)
                            me.$set(row, `price`, ``)
                        }
                    },
                    readonly: function(that, { row }) {
                        if ((isedit && (
                            (me.applyStatus == 2 && (!me.active_apply || (me.active_apply.confirm_number || 0) < 2)) ||
                            (me.applyStatus == 1 && !row.id)
                        )) || mzconfirmp || !row.id
                        ) {
                            return false
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `dic_supplies_id`,
                    label: `dic_supplies_id`,
                    isListable: false,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `spec`,
                    label: `规格`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `firm`,
                    label: `厂商`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `pkg_unit`,
                    label: `包装单位`,
                    isListable: false,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `price`,
                    label: `价格`,
                    isListable: false,
                    readonly: true
                },
                {
                    type: `integer`,
                    prop: `apply_count`,
                    label: `请领数`,
                    isListable: me.applytype == 1,
                    readonly: function(that, { row }) {
                        if (isedit && me.applyStatus == 2 && (
                            (!me.active_apply || ((me.active_apply.confirm_number || 0) < 2)) || !row.id || mzconfirmp)
                        ) {
                            return false
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `integer`,
                    prop: `apply_count_old`,
                    label: `请领数旧`,
                    isListable: false
                },
                {
                    type: `integer`,
                    prop: `supplement_count`,
                    label: `补领数`,
                    isListable: me.applyStatus != 2 && me.applytype == 1,
                    readonly: function(that, { row }) {
                        if ((me.applyStatus == 1 && row.dic_supplies && isedit) || mzconfirmp) {
                            return false
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `integer`,
                    prop: `supplement_count_old`,
                    label: `补领数旧`,
                    isListable: false
                },
                {
                    type: `integer`,
                    prop: `prepare_quantity`,
                    label: `发放数`,
                    isListable: true,
                    readonly: function(that, { row }) {
                        if (me.applyStatus != 0 && me.isHavePermissions(`confirm`)) {
                            return false
                        } else {
                            return true
                        }
                    }
                },
                {
                    type: `integer`,
                    prop: `add_quantity`,
                    label: `转入数`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `integer`,
                    prop: `reduce_quantity`,
                    label: `转出数`,
                    isListable: true,
                    readonly: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    isListable: deletep,
                    fixed: `right`,
                    options: function(that, { row }) {
                        if (row.dic_supplies && (mzconfirmp || !row.id || (me.active_apply && (me.active_apply.confirm_status != 1 || (!row.apply_count_old && !row.supplement_count_old && !row.add_quantity))) || (me.applytype == 2 && me.applyStatus == 2))) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `deleteSupply`,
                                    permission: `default`
                                }
                            ]
                        }
                    }
                }
            ]
        },
        applyStatus() {
            if (!this.queryday) {
                this.queryday = this.$moment().format(`YYYY/MM/DD ${this.supplyApplyScheduleTime}`)
            }
            let nextday = new Date(
                this.$moment(this.queryday)
                    .add(1, `days`)
                    .format(`YYYY/MM/DD ${this.supplyApplyScheduleTime}`)
            )
            var selectday = new Date(this.$moment(this.queryday))
            var now = new Date(this.$moment())
            if (now >= nextday) {
                return 0 // 仅查看
            } else if (now >= selectday && this.applytype == 1) {
                return 1 // 补领
            } else {
                return 2 // 请领
            }
        }
    },
    created() {
        this.loadDay()
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`).then(() => {
            this.wardRooms = _.cloneDeep(this.operation_ward_auth_disabled)
            this.wardRooms = this.wardRooms.map(d => {
                d.operation_room = d.operation_room && _.filter(d.operation_room, r => { return !r.disabled }) || []
                return d
            })
            this.wardRooms = _.filter(this.wardRooms, d => {
                return !d.disabled && d.operation_room.length > 0
            })
            console.log(`wardRooms`, this.wardRooms)
            this.getApplyInfo()
        })
    },
    mounted() {
        // 加载配置列
        this.loadConfigColumns()
        this.configColumnDrop()
    },
    methods: {
        removeSupplies() {
            let that = this
            this.removeView.dialogFormVisible = true
            this.removeView.toRoomId = null
            this.removeView.data = _.filter(that.datalist, d => {
                return d.dic_supplies && (parseInt(d.prepare_quantity || 0) + parseInt(d.add_quantity || 0) - parseInt(d.reduce_quantity || 0)) > 0
            }).map(d => {
                return {
                    ___index: _.now() + Math.random() * Math.random(),
                    id: d.id,
                    dic_supplies_name: d.dic_supplies,
                    dic_supplies_id: d.dic_supplies_id,
                    spec: d.spec,
                    prepare_quantity: parseInt(d.prepare_quantity || 0) + parseInt(d.add_quantity || 0) - parseInt(d.reduce_quantity || 0),
                    reduce_quantity: 0
                }
            })
        },
        removeSuppliesSave() {
            let that = this
            if (!that.removeView.toRoomId) {
                that.$message.warning(`请选择待转移术间`)
                return
            }
            let removedata = _.filter(that.removeView.data, d => {
                return parseInt(d.reduce_quantity || 0) > 0
            })
            if (!removedata || removedata.length == 0) {
                that.$message.warning(`转移数为0，无需操作，请确认待转移耗材`)
                return
            }
            let checkdata = _.filter(removedata, d => {
                return parseInt(d.reduce_quantity || 0) > parseInt(d.prepare_quantity || 0)
            })
            if (checkdata && checkdata.length > 0) {
                that.$message.warning(`转移数不可大于发放数`)
                return
            }
            console.log(`removedata`, removedata)
            var reps = this.myaxios.post(`/api/AcisSystem/SupplieApplyDetail/RemoveSupplies?oldRoomId=${that.active_room.value}&newRoomId=${that.removeView.toRoomId}`, removedata)
            reps.then(data => {
                that.$message.success(`转移成功`)
                that.removeView.dialogFormVisible = false
                that.refreshList()
            })
        },
        getRoomStyle(d) {
            let that = this
            let style = {}
            var styleconfig = this.$root.SupplyApplyRoomStyle
            if (styleconfig && styleconfig != ``) {
                let ls = eval(`(` + styleconfig + `)`)
                style = ls
            }
            if (d.value == (that.active_room && that.active_room.value)) {
                style.backgroundColor = `var(--primary-lighter, rgba(0, 150, 136, 0.2))`
            }
            return style
        },
        refreshList() {
            let that = this
            that.getApplyInfo().then(() => {
                if (that.active_room) {
                    that.loadApplyDetail(that.active_room)
                }
            })
        },
        // 手术间扫码
        scanRoom() {
            let that = this
            if (that.scanroom) {
                that.wardRooms.forEach(w => {
                    w.operation_room && w.operation_room.forEach(r => {
                        if (r.qrcode && that.scanroom == r.qrcode) {
                            that.$message.success(`已定位【${r.label}】`)
                            that.active_room = r
                            that.loadApplyDetail(r, w)
                        }
                    })
                })
            }
        },
        // 获取申请变更对应状态样式
        getChangeColor(changeType) {
            let statecolor = `black`
            if (changeType) {
                switch (changeType) {
                case 1: // 未确认
                case 3: // 发放中
                case 4: // 发放待确认
                    statecolor = `orange`
                    break
                case 2: // 已确认
                case 5: // 已发放
                    statecolor = `green`
                    break
                }
            }
            return {
                color: statecolor
            }
        },
        // 耗材发放扫码
        scanConsumable() {
            let that = this
            if (!this.scancode) {
                this.$message.warning(`请输入或扫码`)
                return
            }
            let req = this.myaxios.post(`/api/AcisSystem/Supplies/SearchScan?barcode=${this.scancode}`)
            req.then(data => {
                if (data) {
                    let hadrow = _.find(that.datalist, { dic_supplies_id: data.id })
                    if (hadrow) {
                        that.datalist = that.datalist.map(d => {
                            if (d.dic_supplies_id == data.id) {
                                // 扫码是发放操作不是申请操作
                                d.prepare_quantity = 1 + parseInt(d.prepare_quantity || 0)
                            }
                            return d
                        })
                    } else if (that.applytype == 2) {
                        that.datalist = _.filter(that.datalist, d => {
                            return d.dic_supplies
                        })
                        that.datalist.push({
                            ___index: _.now() + Math.random() * Math.random(),
                            dic_supplies: data.name,
                            biz_supplie_apply_id: that.active_apply && that.active_apply.id,
                            dic_supplies_id: data.id,
                            apply_count: 0,
                            supplement_count: 0,
                            prepare_quantity: 1,
                            source_mode: 1,
                            spec: data.spec,
                            pkg_unit: data.pkg_unit,
                            price: data.price,
                            firm: data.firm
                        })
                        that.datalist.push({})
                    } else {
                        that.$message.warning(`暂无该耗材申请记录`)
                        return
                    }
                    that.$refs[`scan-code`].scan_val = ``
                    that.$message.success(`扫码成功`)
                } else {
                    that.$message.warning(`暂无该耗材记录`)
                }
            }).catch(e => {
                console.log(e)
            })
        },
        applyLog() {
            let that = this
            that.applyLogView.dialogFormVisible = true
            return new Promise(resolve => {
                var reps = this.myaxios.get(`/api/AcisSystem/SupplieApplyDetailLog/GetSupplieApplyLog?applyId=${that.active_apply.id}`)
                reps.then(data => {
                    that.applyLogView.data = data
                    resolve(data)
                })
            })
        },
        isHavePermissions(permiskey) {
            return this.permissions && ((this.applytype == 1 && this.permissions.findIndex(item => item.permission === `mzSupplyApply:${permiskey}`) != -1) ||
                (this.applytype == 2 && this.permissions.findIndex(item => item.permission === `hlSupplyApply:${permiskey}`) != -1 &&
                (this.permissions.findIndex(item => item.permission === `hlSupplyApply:zq`) != -1 ||
                  this.permissions.findIndex(item => item.permission === `hlSupplyApply:jz`) != -1)
                ))
        },
        isHaveMZPermissions(permiskey) {
            return this.permissions && this.applytype == 1 && this.permissions.findIndex(item => item.permission === `mzSupplyApply:${permiskey}`) != -1 && this.applyStatus != 0
        },
        exportApply() {
            let that = this
            if (!that.active_apply || that.active_apply.id == 0) {
                that.$message.error(`请选择具体申请`)
                return
            }
            let req = that.myaxios.post(`/api/AcisSystem/SupplieApply/GetSupplieApplyInfoForExport?applyId=${that.active_apply.id}`)
            req.then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                that.myaxios.export_excel(data, `${that.active_apply.title || `耗材申请`}.xls`)
            }).catch(e => {
                that.$message.error(`导出数据出错`)
            })
        },
        printApply() {
            let that = this
            if (!that.active_apply || that.active_apply.id == 0) {
                that.$message.error(`请选择具体申请`)
                // 未有耗材申领，先新增
                return
            }
            let doccode = this.applytype == 1 ? `SA001` : (this.roomApplyType == 2 ? `SA002` : `SA003`)
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: this.$root.DOCUMENT[`${doccode}`],
                            id1: `${that.active_apply.id}`,
                            objId: `${that.active_apply.id}`,
                            from: this.$moment(this.queryday).format(`YYYYMMDDHHmm`),
                            to: this.$moment(this.queryday)
                                .add(1, `days`)
                                .format(`YYYYMMDDHHmm`)
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        triggerCollapse() {
            if (this.collapseleft == 0) {
                this.collapseleft = 1
            } else {
                this.collapseleft = 0
            }
            this.$emit(`triggerCollapse`, this.collapseleft)
        },
        loadDay() {
            let that = this
            let today = this.$moment().format(`YYYY/MM/DD ${this.supplyApplyScheduleTime}`)
            let nextday = this.$moment()
                .add(1, `days`)
                .format(`YYYY/MM/DD ${this.supplyApplyScheduleTime}`)
            let selectday = new Date(this.$moment(today))
            let now = new Date(this.$moment())
            if (now >= selectday && that.applytype == 1) {
                that.queryday = nextday
            } else {
                that.queryday = today
            }
        },
        search() {
            let that = this
            let list = []
            if (!this.searchValue) {
                this.datalist = that.all_data_list
            } else {
                this.all_data_list.map(d => {
                    if (d && d.dic_supplies && (d.dic_supplies.indexOf(that.searchValue) != -1 || (d.spec && d.spec.includes(that.searchValue)) || (d.firm && d.firm.includes(that.searchValue)))) {
                        list.push(d)
                    }
                })
                this.datalist = list
            }
        },
        loadApplyDetail(activeroom, ward) {
            let that = this
            that.showRemove = false
            if (ward) {
                that.activeWardRooms = _.filter(ward.operation_room, d => {
                    return d.value != activeroom.value
                })
                console.log(`activeWardRooms`, that.activeWardRooms)
            }
            console.log(`activeroom`, activeroom)
            console.log(`roomApplyType`, that.roomApplyType)
            if (!activeroom) {
                that.datalist = []
                return
            }
            that.active_room = activeroom
            if (that.applytype == 1) {
                that.active_apply = activeroom && activeroom.info && activeroom.info[0]
            } else {
                that.active_apply = activeroom && activeroom.info && _.find(activeroom.info, { surgery_apply_type: parseInt(that.roomApplyType) })
            }
            if (!that.active_apply || that.active_apply.id == 0) {
                that.datalist = []
                if (that.applyStatus == 2 || (that.applyStatus == 1 && (!that.active_apply || !that.active_apply.confirm_status))) {
                    that.datalist.push({})
                }
                that.all_data_list = [...that.datalist]
            } else {
                let req = this.myaxios.get(`/api/AcisSystem/SupplieApplyDetail/GetApplyDetail?applyId=${that.active_apply.id}`)
                req.then(data => {
                    data = _.map(data, (d, index) => {
                        let rowStyle = {}
                        let applyCount = parseInt(d.apply_count || 0)
                        let applyCountOld = parseInt(d.apply_count_old || 0)
                        let supplementCount = parseInt(d.supplement_count || 0)
                        let supplementCountOld = parseInt(d.supplement_count_old || 0)
                        let prepareQuantity = parseInt(d.prepare_quantity || 0)
                        if (prepareQuantity > (applyCount + supplementCount)) {
                            rowStyle.color = `red !important`
                        } else if (prepareQuantity > 0 && prepareQuantity < (applyCount + supplementCount)) {
                            rowStyle.color = `orange !important`
                        }
                        if (applyCount == applyCountOld && supplementCount == supplementCountOld) { // 已确认
                            rowStyle[`background-color`] = `#F0FFF0 !important`
                        } else if ((applyCountOld > 0 || supplementCountOld > 0) && (applyCount != applyCountOld || supplementCount != supplementCountOld)) { // 已确认但调整过
                            rowStyle[`background-color`] = `#FFFFF0 !important`
                        }
                        return {
                            ___index: _.now() + (index + 1) * 1000,
                            id: d.id,
                            biz_supplie_apply_id: d.biz_supplie_apply_id,
                            dic_supplies: d.suppliesInfo && d.suppliesInfo.name,
                            dic_supplies_id: d.dic_supplies_id,
                            apply_count: d.apply_count,
                            apply_count_old: d.apply_count_old,
                            supplement_count: d.supplement_count,
                            supplement_count_old: d.supplement_count_old,
                            prepare_quantity: d.prepare_quantity,
                            spec: d.suppliesInfo && d.suppliesInfo.spec,
                            pkg_unit: d.suppliesInfo && d.suppliesInfo.pkg_unit,
                            price: d.suppliesInfo && d.suppliesInfo.price,
                            firm: d.suppliesInfo && d.suppliesInfo.firm,
                            add_quantity: d.add_quantity,
                            reduce_quantity: d.reduce_quantity,
                            row_style: that.applytype == 1 ? rowStyle : null
                        }
                    })
                    that.datalist = data
                    if ((that.applyStatus == 2 && ((that.active_apply.confirm_number || 0) < 2 || that.applytype == 2)) || that.isHaveMZPermissions(`confirm`) || that.applyStatus == 1) {
                        that.datalist.push({})
                    }
                    that.all_data_list = [...that.datalist]
                    console.log(`this.datalist`, that.datalist)
                    // 是否显示耗材转移  已发放，----且是申请人 && that.active_apply.apply_worker_id == (that.currentUser && that.currentUser.dic_worker_id)
                    if (that.active_apply.change_type >= 3) {
                        that.showRemove = true
                    }
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        confirmSupplies(user) {
            let that = this
            let username = user && user.uid || that.currentUser.username
            let data = _.filter(that.datalist, d => {
                return d.dic_supplies
            })
            if (!data || data.length == 0) {
                that.$message.error(`未填写申请耗材`)
                return
            }
            if (that.isValidRequired(data)) {
                return
            }
            if (that.applytype == 1 && (!this.active_apply || this.active_apply.id == 0)) {
                that.$message.error(`请选择具体申请`)
            } else {
                that.getApplyId().then(() => {
                    that.Save(data).then(() => {
                        that.confirmInfo(username)
                    })
                })
            }
        },
        confirmInfo(username) {
            let that = this
            let req = this.myaxios.post(`/api/AcisSystem/SupplieApply/ConfirmSupplies?applyId=${this.active_apply.id}&username=${username}`)
            req.then(data => {
                if (data != null) {
                    let msg = that.applytype == 1 ? `已确认` : `已发放`
                    that.$message.success(msg)
                } else {
                    that.$message.success(`已保存`)
                }
                that.getApplyInfo().then(() => {
                    that.loadApplyDetail(that.active_room)
                })
            }).catch(e => {
                console.log(e)
            })
        },
        // 急诊直接录入并确认
        confirmSuppliesByWorker() {
            let that = this
            if (!this.alterPasswordDialog.data.uid || !this.alterPasswordDialog.data.pwd) {
                this.$message.error(`请输入用户名或密码`)
                return
            }
            let user = Object.assign({}, this.alterPasswordDialog.data)
            if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                let encryptor = new JSEncrypt()
                encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                user.pwd = encryptor.encrypt(user.pwd)
            }
            this.myaxios
                .post(`api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: user
                })
                .then(result => {
                    that.confirmSupplies(user)
                    that.alterPasswordDialog.dialogFormVisible = false
                })
        },
        saveSupplies() {
            let that = this
            let data = _.filter(that.datalist, d => {
                return d.dic_supplies
            })
            if (!data || data.length == 0) {
                that.$message.error(`未填写申请耗材`)
                // 未有耗材申领，先新增
                return
            }
            if (!that.active_room) {
                that.$message.error(`请选择具体申请`)
                return
            }
            if (that.isValidRequired(data)) {
                return
            }
            that.getApplyId().then(() => {
                that.Save(data).then(() => {
                    that.$message.success(`保存成功`)
                    that.getApplyInfo().then(() => {
                        that.loadApplyDetail(that.active_room)
                    })
                })
            })
        },
        deleteSupply({ row, index }) {
            let that = this
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                if (!(row && row.id)) {
                    this.datalist.splice(index, 1)
                    return
                }
                let req = this.myaxios.delete(`/api/AcisSystem/SupplieApplyDetail/Delete/${row && row.id}`)
                req.then(data => {
                    that.getApplyInfo().then(() => {
                        that.loadApplyDetail(that.active_room)
                    })
                    this.datalist.splice(index, 1)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadTemplates() {
            // 加载可用模板
            let that = this
            return new Promise((resolve, reject) => {
                let req = that.myaxios.get(`/api/AcisSystem/SuppliesTemplate/GetByTemplateType?TemplateType=${that.applytype}`)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        loadTemplatesView() {
            let that = this
            if (!that.active_room) {
                that.$message.error(`请选择具体申请`)
                return
            }
            if (that.active_apply && (that.active_apply.confirm_number || 0) >= 2 && that.applyStatus == 2 && !that.isHavePermissions(`confirm`)) {
                return
            }
            // 加载可选模板，弹出模板选择框
            this.supplies.selected_template = undefined
            this.supplies.datalist = []
            this.checkedRow = []
            this.loadTemplates()
                .then(data => {
                    let groupId = _.groupBy(
                        _.filter(data, d => {
                            return `ow_${d.operating_ward_id_data_auth_filter}` == this.active_ward.value || `rw_${d.recovery_ward_id_data_auth_filter}` == this.active_ward.value || d.owner
                        }),
                        `id`
                    )
                    let ts = _.reduce(
                        groupId,
                        function(result, g, key) {
                            let region = g.map(s => {
                                let ow = s.dic_operating_ward_id && _.find(that.ward_auth, { value: `ow_${s.dic_operating_ward_id}` })
                                let rw = s.dic_recovery_ward_id && _.find(that.ward_auth, { value: `rw_${s.dic_recovery_ward_id}` })
                                return (ow && ow.label) || (rw && rw.label) || that.currentUser.dic_worker_name
                            })
                            let r = {
                                label: g[0].name,
                                value: g[0].id,
                                jianpin: g[0].abbr,
                                code: region.join(`,`),
                                group: _.includes(region, that.currentUser.dic_worker_name) ? `个人模板` : `区域模板`
                            }
                            result.push(r)
                            return result
                        },
                        []
                    )
                    this.supplies.supplies_template = _.orderBy(ts, `group`)
                    this.supplies.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        selectionChange({ row }) {
            console.log(row)
            this.checkedRow = row
            console.log(`checkedRow`, this.checkedRow)
        },
        addTemplateToList() {
            // 确认之后，合并已选模板
            let that = this
            if (this.checkedRow && this.checkedRow.length == 0) {
                this.$message.warning(`请至少勾选一条记录！`)
                return
            }
            let data1 = _.filter(that.datalist, d => {
                return d.dic_supplies
            })
            let slist = this.checkedRow
            let ids = []
            data1 = _.map(data1, d => {
                ids.push(d.dic_supplies_id)
                var item = _.find(slist, x => x.dic_supplies_id == d.dic_supplies_id)
                // 护理的只有发放数
                if (item && that.applytype == 2) {
                    d.prepare_quantity = parseInt(d.prepare_quantity || 0) + parseInt(item.prepare_quantity || 0)
                } else if (item && (that.applyStatus == 2 || that.applytype == 2)) {
                    d.apply_count = parseInt(d.apply_count || 0) + parseInt(item.quantity || 0)
                } else if (item && (that.applyStatus == 1 && that.applytype == 1)) {
                    d.supplement_count = parseInt(d.supplement_count || 0) + parseInt(item.quantity || 0)
                }
                return d
            })
            var otherAdd = _.filter(slist, d => {
                return !_.includes(ids, d.dic_supplies_id)
            })
            var data2 = _.map(otherAdd, d => {
                return {
                    dic_supplies: d.name,
                    biz_supplie_apply_id: that.active_apply && that.active_apply.id,
                    dic_supplies_id: d.dic_supplies_id,
                    apply_count: (that.applyStatus == 2 || that.applytype == 2) ? d.quantity : null,
                    supplement_count: (that.applyStatus == 1 && that.applytype == 1) ? d.quantity : null, // 判断是请领还是补领
                    // 护理的只有发放数
                    source_mode: 1,
                    spec: d.spec,
                    pkg_unit: d.pkg_unit,
                    price: d.price,
                    firm: d.firm
                }
            })
            that.datalist = [...data1, ...data2]
            _.map(that.datalist, (d, index) => {
                d.___index = _.now() + (index + 1) * 1000
                return d
            })
            that.datalist.push({ ___index: _.now(), exists_black: 1 })
            that.all_data_list = [...that.datalist]
            console.log(`abc`, that.datalist)
            this.supplies.dialogFormVisible = false
        },
        SaveAsTemplate() {
            let that = this
            let tmpldatalist = _.filter(that.datalist, d => {
                return d.dic_supplies
            })
            that.saveas.dialogFormVisible = true
            that.saveas.data = {
                supplies: tmpldatalist.map((d, index) => {
                    d.display_order = index + 1
                    // 护理的只有发放数
                    d.quantity = parseInt(d.apply_count || 0) + parseInt(d.supplement_count || 0)
                    return d
                }) || []
            }
        },
        saveAsSuccess() {
            this.$message.success(`另存为模板成功`)
        },
        // 验证必填项
        isValidRequired(datalist) {
            let that = this
            try {
                datalist.forEach(d => {
                    let val1 = parseFloat(d.apply_count || 0)
                    let val2 = parseFloat(d.supplement_count || 0)
                    let val3 = parseFloat(d.prepare_quantity || 0)
                    let val4 = parseFloat(d.add_quantity || 0)
                    if (val1 <= 0 && val2 <= 0 && val3 <= 0 && val4 <= 0) {
                        that.$alert(`<strong>录入的数量必须大于0！</strong>`, `提示`, {
                            dangerouslyUseHTMLString: true,
                            type: `warning`
                        })
                        throw new Error(`EndIterative`)
                    }
                })
            } catch (e) {
                if (e.message != `EndIterative`) throw e
                return e
            }
        },
        getApplyId() {
            let that = this
            return new Promise((resolve, reject) => {
                if (that.active_apply && that.active_apply.id > 0) {
                    resolve(that.active_apply)
                } else {
                    var info = {
                        apply_date: that.$moment(that.queryday).format(`YYYY/MM/DD`),
                        apply_worker_id: that.currentUser && that.currentUser.dic_worker_id,
                        apply_type: that.applytype,
                        dic_operating_room_id: that.active_room.value,
                        title: that.applytype == 1 ? `${that.active_room.label}麻醉耗材申请单` : `${that.active_room.label}护理耗材申请单-${that.roomApplyType == 1 ? `急诊` : `择期`}`,
                        surgery_apply_type: that.applytype == 2 ? that.roomApplyType : null,
                        source_mode: 1
                    }
                    let req = this.myaxios.post(`/api/AcisSystem/SupplieApply/Post`, info)
                    req.then(data => {
                        that.active_apply = data

                        resolve(that.active_apply)
                    }).catch(e => {
                        console.log(e)
                        reject(e)
                    })
                }
            })
        },
        Save(data) {
            let that = this
            return new Promise((resolve, reject) => {
                let updateData = _.filter(data, d => {
                    return d.id && d.id != undefined
                }).map(d => {
                    return {
                        id: d.id,
                        biz_supplie_apply_id: that.active_apply && that.active_apply.id,
                        dic_supplies_id: d.dic_supplies_id,
                        apply_count: d.apply_count,
                        supplement_count: d.supplement_count,
                        prepare_quantity: (!d.prepare_quantity || d.prepare_quantity == ``) ? 0 : d.prepare_quantity
                    }
                })
                let addData = _.filter(data, d => {
                    return !(d.id && d.id != undefined)
                }).map(d => {
                    return {
                        id: 0,
                        biz_supplie_apply_id: that.active_apply && that.active_apply.id,
                        dic_supplies_id: d.dic_supplies_id,
                        apply_count: d.apply_count,
                        supplement_count: d.supplement_count,
                        prepare_quantity: (!d.prepare_quantity || d.prepare_quantity == ``) ? 0 : d.prepare_quantity,
                        source_mode: 1
                    }
                })
                let req = this.myaxios.post(`/api/AcisSystem/SupplieApplyDetail/PostMany?username=${this.alterPasswordDialog.data.uid || this.currentUser.username}`, addData)
                let req1 = this.myaxios.put(`/api/AcisSystem/SupplieApplyDetail/PutMany?username=${this.alterPasswordDialog.data.uid || this.currentUser.username}`, updateData)
                this.myaxios
                    .all(req, req1)
                    .then(([data, data1]) => {
                        resolve(data, data1)
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        SyncSupplies() {},
        getApplyInfo() {
            let that = this
            return new Promise((resolve, reject) => {
                if (!that.wardRooms || that.wardRooms.length == 0) {
                    resolve()
                } else {
                    let req = this.myaxios.get(`/api/AcisSystem/SupplieApply/GetApplyInfo?applyDay=${that.queryday}&applyType=${that.applytype}&surgeryApplyType=${that.roomApplyType || 0}`)
                    req.then(data => {
                        let roomid = that.active_room && that.active_room.value
                        that.wardRooms = that.wardRooms.map(ward => {
                            ward.change_type = 0
                            ward.operation_room =
                                ward.operation_room &&
                                ward.operation_room.map(room => {
                                    let applyinfo = _.filter(data, { dic_operating_room_id: room.value })
                                    let changeinfo = _.filter(applyinfo, { change_type: 1 })
                                    if (changeinfo && changeinfo.length > 0) {
                                        ward.change_type = 1
                                    }
                                    let result = {
                                        ...room,
                                        info: applyinfo || []
                                    }
                                    if (roomid && room.value == roomid) {
                                        that.active_room = result
                                    }
                                    return result
                                })
                            return ward
                        })
                        resolve(that.wardRooms)
                    }).catch(e => {
                        console.log(e)
                        reject(e)
                    })
                }
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        logExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        loadConfigColumns() {
            let req = this.myaxios.get(`api/AcisSystem/SystemServer/GetColumnConfig?tableName=${this.tableName}`)
            req.then(data => {
                let lcs = _.orderBy(this.columnList, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                this.configColumns = lcs
                    .map(c => {
                        return { value: c.prop, label: c.label, isListable: c.isListable }
                    })
                    .filter(d => {
                        return d.label != `unique` && d.isListable
                    })
                this.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
            })
        },
        SaveUserColumns() {
            let uc = this.configColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    table_name: this.tableName
                }
            })
            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                if (this.reload) {
                    this.reload()
                }
            }).catch(e => {})
        },
        configColumnDrop() {
            // if (!this.columnConfig) return
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        showLock() {
            this.alterPasswordDialog.data.uid = null
            this.alterPasswordDialog.data.pwd = null
            this.alterPasswordDialog.dialogFormVisible = true
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            // 加载配置列
            this.loadConfigColumns()
            this.configColumnDrop()
            this.applytype = parseInt(newUrl.query.applytype || 1)
            this.active_room = null
            this.active_apply = null
            this.getApplyInfo().then(() => {
                this.loadApplyDetail(this.active_room)
            })
        },
        queryday: function(newUrl, oldUrl) {
            this.loadConfigColumns()
            this.getApplyInfo().then(() => {
                this.loadApplyDetail(this.active_room)
            })
        },
        roomApplyType: function(newUrl, oldUrl) {
            this.getApplyInfo().then(() => {
                this.loadApplyDetail(this.active_room)
            })
        },
        'supplies.selected_template': function(newval, oldval) {
            // 加载已选模板详情
            if (!newval) return
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/SuppliesTemplate/TemplateItems/${newval}`)
            req.then(template => {
                let r = _.map(
                    _.filter(template, d => {
                        return !d.supplies.is_deleted
                    }),
                    t => {
                        return {
                            dic_supplies_id: t.dic_supplies_id,
                            name: t.supplies.name,
                            code: t.supplies.code,
                            category: t.supplies.category_model && t.supplies.category_model.name,
                            quantity: t.quantity,
                            spec: t.supplies.spec,
                            display_order: t.display_order,
                            pkg_unit: t.supplies.pkg_unit,
                            price: t.supplies.price,
                            firm: t.supplies.firm
                        }
                    }
                )
                that.supplies.datalist = _.orderBy(r, `display_order`)
            })
        }
    }
}
</script>

<style scoped lang="less">
.rooms-wrapper{
    &>.rooms {
        position: relative;
        text-align: left;
        margin: 0px 10px 5px 10px;
        background: #dcdfe6;
        .changetag{
            padding-right: 10px;
            font-size: 16px;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Supplies/SupplyApply.vue